const OPCIONES = [
  {
    valor: 'DIRECTA',
    titulo: 'Compra directa',
    descripcion: 'Se pesa al comprar: cajas, envase y peso bruto.',
  },
  {
    valor: 'PREVIA',
    titulo: 'Compra previa',
    descripcion: 'Acuerdo de kilos y precio; el pesaje llega en la recepción.',
  },
]

function SelectorModalidad({
  valor,
  onCambiar,
  deshabilitado = false,
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Tipo de compra"
      className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2"
    >
      {OPCIONES.map((opcion) => {
        const activa = valor === opcion.valor

        return (
          <button
            key={opcion.valor}
            type="button"
            role="radio"
            aria-checked={activa}
            disabled={deshabilitado}
            onClick={() => onCambiar(opcion.valor)}
            className={`min-h-14 rounded-xl border px-4 py-3 text-left transition disabled:cursor-not-allowed disabled:opacity-60 ${
              activa
                ? 'border-emerald-600 bg-emerald-50 ring-2 ring-emerald-100'
                : 'border-slate-200 bg-white hover:bg-slate-50'
            }`}
          >
            <p
              className={`font-semibold ${
                activa ? 'text-emerald-800' : 'text-slate-900'
              }`}
            >
              {opcion.titulo}
            </p>

            <p className="mt-0.5 text-sm text-slate-500">
              {opcion.descripcion}
            </p>
          </button>
        )
      })}
    </div>
  )
}

export default SelectorModalidad
